import { useToggle } from 'ahooks';
import { Button } from 'antd';

import { EscalateModal } from './EscalateModal';

export const EscalateButton = () => {
  const [isModalOpen, { toggle }] = useToggle(false);

  return (
    <>
      <EscalateModal
        open={isModalOpen}
        onCancel={toggle}
      />

      <Button
        danger
        size='small'
        type='primary'
        onClick={toggle}
      >
        Escalate
      </Button>
    </>
  );
};
